import React, { Component, Fragment } from 'react';
import { Replay } from 'vimond-replay';
import 'vimond-replay/index.css';
import CloseIcon from '@mui/icons-material/Close';


class ShowVideo extends Component {

    render () {  
        
        //let url = "https://webextank-api.webquake.com/api/Recording/"
        let url = "https://" + window.apiurl + "/api/Recording/"
        let token = "/?t=" + encodeURIComponent(this.props.token)
        let source = url + this.props.videoid + token;
        
        return (
            <Fragment>
               <div className="closeright"><span onClick={()=>this.props.closeVideoPage()}>Aufzeichnung schliessen</span> <CloseIcon onClick={()=>this.props.closeVideoPage()} /></div>
              <Replay source={source} />
            </Fragment>
        )
    }
}


export default ShowVideo;